import { Link } from 'react-router-dom';
import { CategorySubCategory } from 'api/categories/_requests';
import team15 from 'assets/img/team/avatar.webp';

const CategoryItem = ({
  categorySubCategory
}: {
  categorySubCategory: CategorySubCategory;
}) => {
  return (
    <div className="card h-100 border-0 shadow-hover shadow-sm transition-all  hover-scale">
      <div className="card-body d-flex flex-column p-3">
        <div className="d-flex align-items-center">
          <div className="position-relative">
            <img
              //   src={team15}
              src="https://png.pngtree.com/png-clipart/20220119/ourmid/pngtree-blue-gradient-circular-arrow-category-icon-png-image_4228956.png"
              alt=""
              className="me-3 rounded-circle shadow-sm"
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'cover',
                border: '2px solid white'
              }}
            />
          </div>
          <div className="flex-grow-1">
            <h5 className="mb-0 text-capitalize fw-semi-bold">
              {categorySubCategory.name}
            </h5>
            <p className="text-dark fs-9 mb-2">
              {categorySubCategory?.categories
                ?.slice(0, 3)
                .map(cat => cat.name)
                .filter(Boolean)
                .join(', ')}
            </p>

            <div className="mt-1">
              <Link
                to={`/store/${categorySubCategory?.slug}`}
                className="btn btn-sm btn-link p-0 text-danger text-decoration-none stretched-link fw-bold"
              >
                VISIT NOW
                <span className="fas fa-chevron-right ms-1 fs-11"></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryItem;
